import { TypeEnum } from 'libs/shared-models/masters/src/lib/enums/stock-item-category-status.enum';
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, } from 'typeorm';

@Entity('employee_week_off_uploads')
export class employeeWeekOfUploads {
    @PrimaryGeneratedColumn('increment', { name: 'week_off_id' })
    weekOffId: number;


    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'employee_id'
    })
    employeeId: number;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'employee_code'
    })
    employeeCode: string;
    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'employee_type'
    })
    employeeType: string;
    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'employee_category'
    })
    employeeCategory: string;
    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'week_off_day'
    })
    weekOffDay: string;


    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime',
    })
    createdAt: Date;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;


    @Column('varchar', {
        nullable: true,
        name: 'updated_user',
        length: 50,
    })
    updatedUser: string | null;

    @Column('varchar', {
        nullable: true,
        name: 'created_user',
        length: 50,
    })
    createdUser: string | null;





}


